<template>
  <div class="input-base">
    <section id="editor" ref="tinymce">
      {{ textInput }}
    </section>
  </div>
</template>

<script>
  import './tinymce/tinymce.min'
  import './tinymce/themes/silver/theme.min'
  import './tinymce/langs/zh_CN'
  import './tinymce/icons/default/icons.min'
  import './tinymce/plugins/preview/plugin.min'
  import './tinymce/plugins/image/plugin.min'
  import './tinymce/plugins/lists/plugin.min'
  import './tinymce/plugins/imagetools/plugin.min'
  import './tinymce/plugins/table/plugin.min'
  export default {
    name: "RipeavTextInput",
    data(){
      return{
        OutputData:'请输入内容',
        inputs:'',
        uploadUrl:'/api/photo/uploadFile',
        id:1,
      }
    },
    // props:['textInput'],

    props: {
      textInput:{
        type: String,
        default: '请输入内容'
      },
    },
    // props2:['msg'],

    watch:{
      textInput: function (newData) {
        this.OutputData = newData
        this.getTextInput(this.inputs)

      }
    },
    methods:{
      getTextInput(res){

      },
    },

    mounted() {

      this.id++
      tinymce.init({
          selector:'#editor',
          language:'zh_CN',
          menubar: 'file edit view table insert format tools',
          // menu:{
          //   bar1:{title:'文件',item:''},
          //   bar2:{title:'编辑',item:'copy paste'},
          //   bar3:{title:'视图',item:'preview'},
          // },
          toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |image imagetools',
          plugins:'preview image lists table ',
          setup:(editor)=>{
            editor.on('init',(e)=>{
              editor.setContent(this.OutputData)
            })
          },
          init_instance_callback:(editor)=>{
            editor.on('input',(e)=>{
              this.$emit('input',e.target.innerHTML)
            })
            editor.on('change',(e)=>{
              this.$emit('change',e.level.content)
            })
          },
          images_upload_handler: (blobInfo, success, failure) => {
            let params=new FormData()
            params.append('file',blobInfo.blob())
            this.$axios.post('/api/photo/uploadFile',params).then(res=>{
              if(res.data.code==200){
                success('http://'+res.data.data)  //上传成功，在成功函数里填入图片路径
              }else{
                failure("上传失败")
              }
            }).catch(()=>{
              failure("上传出错，服务器开小差了呢")
            })
          },
          // images_upload_url: '/api/photo/uploadFile',
        })
    },
    destroyed() {
      tinymce.remove()
    },

  }
</script>

<style scoped>
  @import url('./tinymce/skins/ui/oxide/skin.min.css');
  .input-base{
    margin-top: 40px;
  }
</style>